import {rotinasRecepcao} from "./rotinas"

export default function () {
  return rotinasRecepcao;
}